document.addEventListener("DOMContentLoaded", () => {

  const faqItems = document.querySelectorAll(".Faq__Item");

  faqItems.forEach(item => {

    const button = item.querySelector(".Faq__Question");
    const wrapper = item.querySelector(".Faq__AnswerWrapper");

    if(!button || !wrapper) return;

    button.addEventListener("click", () => {

      const isOpen = item.getAttribute("aria-expanded") === "true";

      item.setAttribute("aria-expanded", !isOpen);
      wrapper.setAttribute("aria-hidden", isOpen);

      if(!isOpen){
        wrapper.style.maxHeight = wrapper.scrollHeight + "px";
      }else{
        wrapper.style.maxHeight = "0px";
      }

    });

  });


  /* =========================
     Sticky Summary Active State
  ========================= */

  const sections = document.querySelectorAll(".Faq__Section");
  const links = document.querySelectorAll(".FaqSummary__Item");

  if(sections.length && links.length){

    const observer = new IntersectionObserver((entries)=>{

      entries.forEach(entry=>{

        if(entry.isIntersecting){

          links.forEach(li=>li.classList.remove("is-active"));

          const id = entry.target.querySelector(".Anchor")?.id;

          if(!id) return;

          const active = document.querySelector(`a[href="#${id}"]`);

          if(active){
            active.closest(".FaqSummary__Item").classList.add("is-active");
          }

        }

      });

    },{
      rootMargin:"-120px 0px -60% 0px",
      threshold:0
    });

    sections.forEach(section=>observer.observe(section));

  }


  /* =========================
     Anchor Smooth Scroll
  ========================= */

  document.querySelectorAll(".FaqSummary__Link").forEach(link=>{

    link.addEventListener("click",(e)=>{

      e.preventDefault();

      const target = document.querySelector(link.getAttribute("href"));

      if(!target) return;

      const offset = Number(link.dataset.offset || 80);

      window.scrollTo({
        top: target.getBoundingClientRect().top + window.pageYOffset - offset,
        behavior:"smooth"
      });

    });

  });

});